import { v4 as uuidv4 } from 'uuid';
import { matchPath } from "react-router";
import {
	ActionPayload,
	ActionSource,
	ActionEvent,
	ActionType,
	BrandliveEvent
} from '../../types/working-model';

export { default as useTracking } from './use-tracking';
import { DebugDefaultRouteMap, DefaultRouteMap } from '../../components/live-event/hooks/use-route-map';

const matchesPaths = (pathname: string, paths: string[]) => {
	return matchPath(pathname, { path: paths, exact: true });
};

const isHome = (pathname: string) => {
	return matchesPaths(pathname, [
		DebugDefaultRouteMap.Home,
		DefaultRouteMap.Home
	]);
};

const isSessions = (pathname: string) => {
	return matchesPaths(pathname, [
		DebugDefaultRouteMap.Sessions,
		DefaultRouteMap.Sessions
	]);
};

const isCustomPage = (pathname: string) => {
	return matchesPaths(pathname, [
		DebugDefaultRouteMap.CustomPage,
		DefaultRouteMap.CustomPage
	]);
};

const isProfile = (pathname: string) => {
	return matchesPaths(pathname, [
		DebugDefaultRouteMap.AttendeeProfile,
		DefaultRouteMap.AttendeeProfile
	]);
};

const isDirectory = (pathname: string) => {
	return matchesPaths(pathname, [
		DebugDefaultRouteMap.Directory,
		DefaultRouteMap.Directory
	]);
};

export const getPageTrackingParams = (
	bl_profile: number,
	eventBundle: BrandliveEvent,
	registration_id: string,
	pageSessionUuid: string,
	url: string
): ActionPayload | null => {
	const baseActionParams = {
		action: ActionEvent.PageView,
		action_type: ActionType.Active,
		action_id: uuidv4(),
		bl_profile,
		channel_id: eventBundle.channel,
		event_id: eventBundle.event || 0,
		registration_id,
		source_app: 'events',
		source_app_version: process.env.REACT_APP_VERSION ?? '0',
		user_session_uuid: pageSessionUuid
	};

	// Home page
	if (isHome(url)) {
		return {
			...baseActionParams,
			source_id: eventBundle.homepage?.homepage || 0,
			source_type: ActionSource.Home
		};
	}

	// Agenda
	if (isSessions(url)) {
		return {
			...baseActionParams,
			source_id: 0,
			source_type: ActionSource.Agenda
		};
	}

	const customPage = isCustomPage(url);
	// Custom pages
	if (customPage) {
		return {
			...baseActionParams,
			source_id: eventBundle?.custom_pages?.find(page => page.path === (customPage.params as { customPath: string }).customPath)?.custom_page || 0,
			source_type: ActionSource.CustomPage
		};
	}

	const profilePage = isProfile(url);
	// Profile
	if (profilePage) {
		return {
			...baseActionParams,
			source_id: (profilePage.params as { attendeeId: string }).attendeeId,
			source_type: ActionSource.Profile
		};
	}

	// Directory
	if (isDirectory(url)) {
		return {
			...baseActionParams,
			source_id: 0,
			source_type: ActionSource.Directory
		};
	}

	// null if its a page we don't currently want to track
	return null;
};

export const VIDEO_TRACKING_MILESTONES: ReadonlyArray<number> = [10, 25, 50, 75, 90, 100];
